import "@/App.css";
import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import CookieBanner from "@/components/site/CookieBanner";
import ScrollToTop from "@/components/site/ScrollToTop";
import Home from "@/pages/Home";
import Logistics from "@/pages/Logistics";
import Supermarket from "@/pages/Supermarket";
import Coffee from "@/pages/Coffee";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import { CookiesPolicy, PrivacyPolicy, Terms } from "@/pages/Legal";

function SmoothScroll() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.11, smoothWheel: true });
    window.__lenis = lenis;
    let raf = requestAnimationFrame(function loop(t) {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    });
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);
  return null;
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SmoothScroll />
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/logistics" element={<Logistics />} />
          <Route path="/supermarket" element={<Supermarket />} />
          <Route path="/coffee" element={<Coffee />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/cookies-policy" element={<CookiesPolicy />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="*" element={<Home />} />
        </Routes>
        <Footer />
        <CookieBanner />
      </BrowserRouter>
    </div>
  );
}
